import { UniqueSellingPointsSmall } from "./UniqueSellingPointsSmall";
export { UniqueSellingPointsSmall };
